import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<title>Group 14</title><g id=\"Design-desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"homepage\" transform=\"translate(-1334.000000, -11.000000)\" fill=\"currentColor\"><g id=\"Group-14\" transform=\"translate(1334.000000, 11.000000)\"><rect id=\"Rectangle\" x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect><rect id=\"Rectangle\" transform=\"translate(8.500000, 8.500000) rotate(90.000000) translate(-8.500000, -8.500000) \" x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></g></g>", 2)
  ])))
}
export default { render: render }